<section style="overflow-y: scroll;height: 190px;">
 <div >
  <div class="wrapper">
    <div class="styled-input">
        <label class="diagnostic-label">Current Medication Plan</label>
        <button type="button" class="add-boutton" (click)="openDialog()" style="left: 420px;" name="Add">Add</button>

    </div>
</div>
 </div>
</section>

 <BR>
  <BR>
  <section style="top: 350px;overflow-y: scroll;height: 250px;">

    <table style="left: 50px;" >

      <tr *ngFor="let item of cancertreatmentList; let i = index" style="text-align: left;">
        <label >       </label>
        <td data-column="Item Date" >
          <label style="font-weight: bold;">{{item.trdate}}  {{item.username}}</label>                                                                                                                             
          <button type="button" class="fa fa-pencil" style="left: 400px;border-style: none;background-color: white;color: green;" matTooltip="Edit" name="Add" (click)="EditDecision(item)"></button>
          <button type="button" class="fa fa-trash" style="left: 350px;border-style: none;background-color: white;color: red;" matTooltip="Delete" name="Delete" (click)="MessegeDelete(item)"></button>
          <br>

          <label >{{item.trnotes}} </label>
          <br>
          <br>
        </td>

      </tr>


    </table>
  </section>



